<template>
  <Block type="accountSetting" id="account-follow">
    <div class="generate-followCode-contianer" v-if="showGenerateContainer">
      <div class="follow-rule-wrap">
        <p>{{ languages.account_czsm1 }}</p>
        <p>{{ languages.account_czsm2 }}</p>
        <p>
          {{ languages.account_czsm3 }}
          <a
            href="javascript:void(0)"
            @click="showBindAccountDialog"
            class="to-bind"
          >
            {{ languages.account_czsm4 }}
          </a>
          {{ languages.account_czsm5 }}
        </p>
      </div>
      <form>
        <Editor
          v-model="pw"
          editorClass="editor"
          class="editor-wrapper relative"
          type="passportAccountEditor"
          :placeholder="languages.account_wzfdmm"
        ></Editor>
        <Editor
          v-model="repw"
          editorClass="editor"
          class="editor-wrapper relative"
          type="passportAccountEditor"
          :placeholder="languages.account_qzcsrmm"
        ></Editor>
        <label class="submit-wrapper">
          <Button
            class="btn follow-btn"
            data-asyncbtn
            type="lightfill"
            @click="geterateMigrate"
          >
            {{ languages.account_fxyjm }}
          </Button>
        </label>
      </form>
    </div>
    <div class="show-followCode-contianer" v-else>
      <div class="follow-rule-wrap">
        <p>{{ languages.account_yjmsm1 }}</p>
        <p>{{ languages.account_yjmsm2 }}</p>
        <p>{{ languages.account_yjmsm3 }}</p>
        <p>{{ languages.account_yjmsm4 }}</p>
      </div>
      <div class="follow-code-warp">
        <p class="follow-code-text">{{ languages.account_yjm }}</p>
        <p class="follow-code-content">{{ oldFollowCode }}</p>
      </div>
      <div class="follow-ops">
        <button
          class="btn copy-code-btn"
          type="button"
          @click="copyOldFollowCode"
        >
          {{ languages.account_fz }}
        </button>
        <button
          class="btn generate-code-btn"
          type="button"
          @click="showGenCodeContainer"
        >
          {{ languages.account_cxfx }}
        </button>
      </div>
    </div>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>

<script>
import Dialog from '../../components/passport/Dialog';
import bridge from '../../utiles/bridge';
import { SHOW_DIALOG, BINDING_DIALOG } from '../../store/dialog';
import { GET_MIGRATE, GENERATE_MIGRATE } from '../../store/account';

export default {
  data() {
    return {
      showGenerateContainer: true,
      pw: '',
      repw: '',
      showPopup: false,
      errTips: '',
    };
  },
  computed: {
    showDialog() {
      return this.$store.state.dialog.showDialog;
    },
    oldFollowCode() {
      let oldCode = this.$store.state.account.oldFollowCode;
      this.showGenerateContainer = oldCode == '';
      return oldCode;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
  },
  watch: {
    oldFollowCode(newCode) {
      this.showGenerateContainer = newCode == '';
    },
  },
  beforeCreate() {
    this.$store.dispatch(GET_MIGRATE);
  },
  methods: {
    showBindAccountDialog() {
      this.$store.dispatch(SHOW_DIALOG, BINDING_DIALOG);
    },
    showGenCodeContainer() {
      this.showGenerateContainer = true;
    },
    copyOldFollowCode() {
      bridge.callSdkMethod('copyText', {
        content: this.oldFollowCode + '',
      });
    },
    geterateMigrate() {
      this.$store
        .dispatch(GENERATE_MIGRATE, {
          pw: this.pw || '',
          repw: this.repw || '',
        })
        .then(() => {
          this.$clearDisable();
        })
        .catch(err => {
          this.showPopup = true;
          this.errTips = err.message;
          this.$clearDisable();
        });
      // .then((oldFollowCode)=>{
      //      this.oldFollowCode = oldFollowCode;
      //     this.showGenerateContainer = oldFollowCode == "";
      // })
    },
  },
  components: {
    Dialog,
  },
};
</script>
